"use client";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxHiddenInput/ComboboxHiddenInput.tsx
function ComboboxHiddenInput({ value, valuesDivider = ",", ...others }) {
	return /* @__PURE__ */ jsx("input", {
		type: "hidden",
		value: Array.isArray(value) ? value.join(valuesDivider) : value ? `${value}` : "",
		...others
	});
}
ComboboxHiddenInput.displayName = "@mantine/core/ComboboxHiddenInput";
//#endregion
export { ComboboxHiddenInput };

//# sourceMappingURL=ComboboxHiddenInput.mjs.map